import { DashboardNotificationType } from '@web/dashboard/types';
import { DashboardNotification } from '@web/dashboard/types/DashboardNotification';
import { ShiftTaskDashboardNotification } from '@web/shiftTasks/types/ShiftTaskDashboardNotification';

export const isShiftTasksDashboardNotification = (
  notification: DashboardNotification
): notification is ShiftTaskDashboardNotification =>
  notification.type === DashboardNotificationType.shiftTaskCompleted ||
  notification.type === DashboardNotificationType.shiftTaskDueSoon ||
  notification.type === DashboardNotificationType.shiftTaskOverdue;
